<template>
  <div
    class="header-desktop-main"
    :class="{ 'header-bordered': $route.path !== '/' }"
  >
    <v-app-bar class="overflow-hidden" color="#fafafa" height="96px" flat>
      <v-sheet
        class="d-flex justify-space-between align-center mx-auto"
        color="transparent"
        max-width="1194px"
        width="100%"
        height="100%"
      >
        <router-link to="/">
          <img
            v-if="informations.img"
            :src="files + informations.img"
            :alt="informations.name"
            class="d-block"
            height="74px"
          />
        </router-link>

        <v-sheet height="100%" color="transparent" class="d-flex align-center">
          <div class="position-relative header-desktop-main-navigation">
            <div
              v-for="({ text, to, submenu }, key) in menu"
              :key="key"
              class="d-inline-flex"
            >
              <v-btn
                class="
                  primary--text
                  text-body-1 text-md-h5 text-none
                  font-italic
                  px-2 px-lg-3
                  py-5
                  nav-link
                "
                :class="{ 'ml-2': key > 0 }"
                :to="to"
                active-class="font-weight-medium nav-link-active"
                tile
                depressed
                text
                v-if="!submenu"
              >
                <span class="font-secondary">
                  {{ text }}
                </span>
              </v-btn>

              <v-menu v-else offset-y tile>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="
                      primary--text
                      text-body-1 text-md-h5 text-none
                      font-italic
                      px-2 px-lg-3
                      py-5
                    "
                    :class="{ 'ml-2': key > 0 }"
                    active-class="font-weight-medium nav-link-active"
                    tile
                    depressed
                    text
                  >
                    <span class="font-secondary">{{ text }}</span>
                    <v-icon class="ml-3" size="12"> fa-caret-down </v-icon>
                  </v-btn>
                </template>
                <v-list tile>
                  <v-list-item
                    v-for="(item, index) in submenu"
                    :to="item.to"
                    :key="index"
                  >
                    <v-list-item-title class="grey--text text--darken-3">
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>

          <v-sheet
            height="100%"
            color="transparent"
            class="
              d-flex
              align-center
              mr-n1
              position-relative
              header-desktop-main-social
            "
          >
            <div class="position-relative">
              <template
                v-for="({ title, link, icon, size }, keySocial) in social"
              >
                <div :key="keySocial" class="d-inline-flex">
                  <v-btn
                    small
                    color="#87868A"
                    class="white--text mx-1 header-desktop-main-social-btn"
                    :href="link"
                    target="_blank"
                    :title="title"
                    depressed
                    fab
                  >
                    <v-icon :size="size">{{ icon }}</v-icon>
                  </v-btn>
                </div>
              </template>
            </div>
          </v-sheet>
        </v-sheet>
      </v-sheet>
    </v-app-bar>
  </div>
</template>

<script>
import { getSocial } from "../../../utils/getSocial";

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    social() {
      return this.getSocial(this.informations);
    },
  },
  methods: {
    getSocial,
  },
};
</script>

<style lang="scss" scoped>
.header-desktop-main::v-deep {
  .v-toolbar__content {
    padding-bottom: 0;
    padding-top: 0;
  }
}

.header-desktop-main {
  &.header-bordered {
    border-bottom: 1px solid #b7b7b7 !important;
  }

  .nav-link {
    &:before {
      opacity: 0 !important;
    }
  }

  &-navigation {
    z-index: 9;
  }

  &-social {
    padding-left: 70px;

    :first-child {
      z-index: 2;
    }

    &:after {
      content: "";
      border-color: transparent #fafafa transparent transparent;
      border-style: solid;
      border-width: 96px 70px 0 96px;
      height: 0;
      left: 0;
      position: absolute;
      top: 0;
      transform: rotate(180deg);
      width: 0;
      z-index: 1;
    }

    &:before {
      background-image: url(../../../assets/img/bg-header-social.jpg);
      background-size: cover;
      background-position: center;
      bottom: 0;
      content: "";
      left: 0;
      opacity: 0.6;
      position: absolute;
      top: 0;
      width: 50vw;
      z-index: 1;
    }

    &-btn {
      box-shadow: inset 0px 2px 2px rgba(0, 0, 0, 0.15);
    }
  }
}
</style>
